import commandEngine from './CommandEngine.js';
import jxWindowManager from '../../../../../JxControls/JxWindowManager/JxWindowManager.jsx';
import { TIMEZONE_OPTIONS } from '../../../../../JxControls/TestWindow/clockTimezones.js';

/**
 * Registers the /clock command with the CommandEngine.
 * Call once at module load from YourLibraryTab.
 *
 * /clock <IANA timezone> — opens clock with given timezone (default: Europe/Amsterdam)
 * Param options use label (short city name) for display and value (full IANA string) for insertion.
 */
export function registerClockCommand() {
    commandEngine.register('/clock', {
        hint: 'Open clock',
        params: [{ name: 'timezone', options: TIMEZONE_OPTIONS }],
        handler: ([tz]) => {
            jxWindowManager.openWindow('JxClockTestForm', 'global', { timeZone: tz ?? 'Europe/Amsterdam' }, true);
        },
    });
}
